import {createContext} from 'react'

const navigatorOpenContext = createContext()
const portfolioPathContext = createContext()

export {navigatorOpenContext, portfolioPathContext}